import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUserData } from "../../redux/state/authReduser/authentification.selectors";
import { Box, Card, CardContent, Typography, Divider } from "@mui/material";
import orderHistoryStyles from "./OrderHistory.styles";
import { useLocation } from "react-router-dom";

const OrderHistory = () => {
  const userData = useSelector(selectUserData);
  const location = useLocation();

  useEffect(() => {
    if (!sessionStorage.getItem(`reloaded-${location.pathname}`)) {
      sessionStorage.setItem(`reloaded-${location.pathname}`, "true");
      window.location.reload();
    }
  }, [location.pathname]);
  
  if (!userData?.orderHistory?.length) {
    return (
      <Box sx={orderHistoryStyles.container}>
        <Typography variant="h6">История заказов пуста</Typography>
      </Box>
    );
  }

  return (
    <Box sx={orderHistoryStyles.container}>
      {userData.orderHistory.map((order) => (
        <Card key={order._id} sx={orderHistoryStyles.card}>
          <CardContent>
            <Typography variant="h6" sx={orderHistoryStyles.productName}>
              {order.productName}
            </Typography>

            <Typography variant="body2" sx={orderHistoryStyles.detailText}>
              <strong>Вес:</strong> {order.weight} г
            </Typography>
            <Typography variant="body2" sx={orderHistoryStyles.detailText}>
              <strong>Район:</strong> {order.district}
            </Typography>
            <Typography variant="body2" sx={orderHistoryStyles.detailText}>
              <strong>Оплата:</strong> {order.paymentMethod}
            </Typography>
            <Typography variant="body2" sx={orderHistoryStyles.detailText}>
              <strong>Дата создания:</strong> {new Date(order.createdAt).toLocaleString()}
            </Typography>

           
            <Typography
              variant="body2"
              sx={{
                ...orderHistoryStyles.status,
                color: "red", 
              }}
            >
              Не оплачено
            </Typography>
          </CardContent>
          <Divider sx={{ margin: "10px 0" }} />
        </Card>
      ))}
    </Box>
  );
};

export default OrderHistory;
